export default "/traffic cone.glb";